import React from 'react';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
  position: absolute;
  left: 0px;
  bottom: 18%;
  width: 100%;
  z-index: 2;
  white-space: pre;
  text-shadow: 2px 2px ${(props) => props.theme.colors.smokeWhite};
  text-align: center;
  font-size: 1.275em;
  display: none;

  &::after {
    display: inline-block;
    width: 1em;
    text-align: left;
  }
`;

export const Loading = ({ loadingRef, message = 'Loading 0%' }) => <LoadingContainer ref={loadingRef}>{message}</LoadingContainer>;
